export enum ValidationAction {
	StopOnTheFirstRecordWithAnError,
	ValidateAllRecords,
}
